/**
 * @desc 根据code获取供应商详情
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(params: API.srm.supplierInfo.getDetailByCode.Params, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierInfo/getBySupplierCode`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
